import { Badge } from '@/components/Badge';
import type { BadgeTone } from '@/components/Badge';

/**
 * The POS's own status strings are mirrored verbatim, so they are matched
 * defensively and any unknown value still renders as a neutral badge rather
 * than disappearing.
 */
export function humanise(value: string): string {
  const text = value.trim().replace(/_/g, ' ');
  if (!text) return 'Unknown';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function paymentTone(status: string): BadgeTone {
  switch (status.trim().toLowerCase()) {
    case 'paid':
    case 'settled':
      return 'success';
    case 'unpaid':
    case 'overdue':
      return 'danger';
    case 'partial':
    case 'partially paid':
    case 'pending':
      return 'warning';
    default:
      return 'neutral';
  }
}

export function PaymentStatusBadge({ status }: { status: string }) {
  return (
    <Badge tone={paymentTone(status)} dot>
      {humanise(status)}
    </Badge>
  );
}

function orderTone(status: string): BadgeTone {
  switch (status.trim().toLowerCase()) {
    case 'completed':
    case 'delivered':
    case 'closed':
      return 'success';
    case 'cancelled':
    case 'canceled':
    case 'void':
    case 'returned':
      return 'danger';
    case 'pending':
    case 'preparing':
    case 'out for delivery':
    case 'ready':
      return 'warning';
    default:
      return 'neutral';
  }
}

export function OrderStatusBadge({ status }: { status: string }) {
  return <Badge tone={orderTone(status)}>{humanise(status)}</Badge>;
}
